import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-jalali';

import * as styles from '../styles';
import { ServerDate } from '../containers/ServerDate';


export default class Day extends React.PureComponent {
    static propTypes = {
        day: PropTypes.object.isRequired,
        isCurrentMonth: PropTypes.bool,
        disabled: PropTypes.bool,
        selected: PropTypes.bool,
        inRange: PropTypes.bool,
        onClick: PropTypes.func,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.selected !== this.props.selected ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.isCurrentMonth !== this.props.isCurrentMonth ||
            nextProps.inRange !== this.props.inRange ||
            nextProps.inHoveredRange !== this.props.inHoveredRange;
    }

    handleClick(event) {
        event.stopPropagation();
        const {onClick, day} = this.props;

        if (onClick)
            onClick(day);
    }

    render() {
        return <button
            type="button"
            onClick={this.handleClick.bind(this)}
            disabled={this.props.disabled}
            style={{
                ...this.props.selected
                    ? styles.activeButton
                    : this.props.inHoveredRange
                        ? {...styles.button, backgroundColor: styles.successBorderColor}
                        : this.props.inRange
                            ? {...styles.button, backgroundColor: styles.successBackColor}
                            : styles.button,
                boxShadow: undefined,
                float: 'right',
                width: 'calc(100% / 7)',
                height: '2.5em',
                minWidth: undefined,
                color: this.props.isCurrentMonth ? 'black' : '#9a9a9a',
                boxSizing: 'border-box',
                ...(this.props.day.format('jYYYYjMMjDD') === moment(ServerDate()).format('jYYYYjMMjDD')
                    ? {border: '.0625em solid #cacaca'}
                    : {}
                ),
            }}
            onMouseEnter={this.props.onMouseEnter}
            onMouseLeave={this.props.onMouseLeave}>
            {this.props.day.format('jD').persian()}
        </button>;
    }
}
